"use client";

import { c as _c } from "react/compiler-runtime";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import type { BaseRendererProps } from "../types/renderer-props";
import { withArweaveFallback } from "../utils/arweave-fallback";
export default function NFTVideoRenderer(props) {
  const $ = _c(16);
  const t0 = `${styles.nftAnimation} ${props.heightStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
  let t1;
  if ($[0] !== props.height || $[1] !== props.nft.contract || $[2] !== props.nft.id || $[3] !== props.showBalance) {
    t1 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[0] = props.height;
    $[1] = props.nft.contract;
    $[2] = props.nft.id;
    $[3] = props.showBalance;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.id ?? `video-${props.nft.id}`;
  const t3 = !props.showOriginal && "metadata" in props.nft && props.nft.compressed_animation ? props.nft.compressed_animation : props.nft.animation;
  const t4 = props.imageStyle;
  let t5;
  if ($[5] !== props.nft) {
    t5 = withArweaveFallback(t6 => {
      const {
        currentTarget
      } = t6;
      if ("metadata" in props.nft && currentTarget.src === props.nft.compressed_animation) {
        currentTarget.src = props.nft.animation;
      } else {
        if ("metadata" in props.nft) {
          currentTarget.src = props.nft.metadata.animation;
        }
      }
    });
    $[5] = props.nft;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.imageStyle || $[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <video id={t2} autoPlay={true} muted={true} controls={true} loop={true} playsInline={true} preload="auto" src={t3} className={t4} onError={t5} />;
    $[7] = props.imageStyle;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t6) {
    t7 = <Col className={t0}>{t1}{t6}</Col>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}